// footer
// 为每个 .mmvapor_footer_b_Submenu 元素添加点击事件监听器  
document.querySelectorAll('.mobile_only .mmvapor_footer_b_Submenu').forEach(function (Submenu) {
  Submenu.addEventListener('click', function () {
    // 查找紧接着的 .mmvapor_footer_b_Submenu_link 元素  
    const Submenu_link = Submenu.nextElementSibling;
    while (Submenu_link && !Submenu_link.classList.contains('mmvapor_footer_b_Submenu_link')) {
      Submenu_link = Submenu_link.nextElementSibling;
    }

    if (!Submenu_link) {
      // 如果没有找到 .mmvapor_footer_b_Submenu_link 元素，则不执行后续操作  
      return;
    }

    // 获取 .mmvapor_footer_b_Submenu_link 元素的总高度（可能需要先设置为可见才能获取到实际高度）  
    // 注意：这里可能需要额外的逻辑来确保能够获取到正确的总高度  
    var totalHeight = Submenu_link.scrollHeight;

    // 获取当前 .Submenu_link 元素的高度样式  
    var currentHeightStyle = window.getComputedStyle(Submenu_link).getPropertyValue('height');

    // 检查当前高度是否为 0（可能需要转换为数字进行比较）  
    if (currentHeightStyle === '0px' || parseInt(currentHeightStyle, 10) === 0) {
      // 展开：添加 .Submenu_active 类到 .Submenu_right 子元素（假设它是 .Submenu 的直接子元素）  
      var mnavRight = Submenu.querySelector('.mmvapor_footer_b_Submenu_right');
      if (mnavRight) {
        mnavRight.classList.add('Submenu_active');
      }

      // 设置 .Submenu_link 元素的高度为总高度  
      Submenu_link.style.height = totalHeight + 'px';
    } else {
      // 折叠：移除 .Submenu_active 类  
      var mnavRight = Submenu.querySelector('.mmvapor_footer_b_Submenu_right');
      if (mnavRight) {
        mnavRight.classList.remove('Submenu_active');
      }

      // 设置 .Submenu_link 元素的高度为 0  
      Submenu_link.style.height = '0px';
    }
  });
});


// 递归向上更新所有父级 footermo_Submenu_link 的 max‑height
function updateParentMaxHeight(el) {
  let parent = el.parentElement;
  while (parent) {
    if (parent.classList.contains('footermo_Submenu_link')) {
      parent.style.maxHeight = parent.scrollHeight + 'px';
    }
    parent = parent.parentElement;
  }
}

// 绑定子菜单点击，只处理 div.footermo_Submenu
document.querySelectorAll('.footermo_Submenu_item div.footermo_Submenu').forEach(function (Submenu) {
  Submenu.addEventListener('click', function () {
    const Submenu_link = Submenu.nextElementSibling;
    let targetLink = Submenu_link;
    while (targetLink && !targetLink.classList.contains('footermo_Submenu_link')) {
      targetLink = targetLink.nextElementSibling;
    }
    if (!targetLink) return;

    const currentMaxH = parseInt(window.getComputedStyle(targetLink).maxHeight, 10);
    if (currentMaxH === 0 || isNaN(currentMaxH)) {
      // 展开子面板
      const mnavRight = Submenu.querySelector('.footermo_Submenu_right');
      if (mnavRight) mnavRight.classList.add('footermo_Submenu_active');
      targetLink.style.maxHeight = targetLink.scrollHeight + 'px';
      updateParentMaxHeight(targetLink);
    } else {
      // 收起子面板
      const mnavRight = Submenu.querySelector('.footermo_Submenu_right');
      if (mnavRight) mnavRight.classList.remove('footermo_Submenu_active');
      targetLink.style.maxHeight = '0px';
      updateParentMaxHeight(targetLink);
    }
  });
});

// 点击菜单内链接，关闭当前所在子面板
document.querySelectorAll('.footermo_Submenu_item a').forEach(aEl => {
  aEl.addEventListener('click', function () {
    let linkWrap = this.closest('.footermo_Submenu_link');
    if (!linkWrap) return;

    linkWrap.style.maxHeight = '0px';
    const trigger = linkWrap.previousElementSibling;
    if (trigger && trigger.classList.contains('footermo_Submenu')) {
      const rightEl = trigger.querySelector('.footermo_Submenu_right');
      if (rightEl) rightEl.classList.remove('footermo_Submenu_active');
    }
    updateParentMaxHeight(linkWrap);
  })
});
